import * as React from "react"
const SvgSidebarRight = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7.5 15.371q0 .35.3.475.3.126.55-.125l2.45-2.45q.3-.3.3-.7t-.3-.7l-2.45-2.45q-.25-.25-.55-.125-.3.126-.3.475zm-2.5 6.2q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19.57v-14q0-.824.587-1.412A1.93 1.93 0 0 1 5 3.57h14q.824 0 1.413.588Q21 4.746 21 5.57v14a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 19 21.57H5Zm11-2h3v-14h-3zm-2 0v-14H5v14z" />
  </svg>
)
export default SvgSidebarRight
